const paymentAttempts = {
  apiClient: null,
  path: '/admin/payment-attempts',

  setClient(apiClient) {
    this.apiClient = apiClient;
  },

  async getAll(params = {}) {
    try {
      const queryParams = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== '') {
          queryParams.append(key, value);
        }
      });
      const queryString = queryParams.toString();
      const url = queryString ? `${this.path}?${queryString}` : this.path;
      const response = await this.apiClient.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getSummary() {
    try {
      const response = await this.apiClient.get(`${this.path}/summary`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getQuotesWithIssues(params = {}) {
    try {
      const queryParams = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== '') {
          queryParams.append(key, value);
        }
      });
      const queryString = queryParams.toString();
      const url = queryString ? `${this.path}/issues?${queryString}` : `${this.path}/issues`;
      const response = await this.apiClient.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getByQuoteId(quoteId) {
    try {
      const response = await this.apiClient.get(`${this.path}/quote/${quoteId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async retryPayment(quoteId, reason = null) {
    try {
      const response = await this.apiClient.post(`${this.path}/quote/${quoteId}/retry`, { reason });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async suspendQuote(quoteId, reason = null) {
    try {
      const response = await this.apiClient.post(`${this.path}/quote/${quoteId}/suspend`, { reason });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async reactivateQuote(quoteId) {
    try {
      const response = await this.apiClient.post(`${this.path}/quote/${quoteId}/reactivate`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default paymentAttempts;
